module.exports = __webpack_public_path__ + "img/slika43.8e6180ae.jpg";